<template>
    <div>
        <template v-if="creative_type=='AD CREATIVES'">
            <div class="row justify-content-center top-social-ad-creatives mt-5">
                <template v-if="isBuilt">
                    <h1 class="section-name col-12 mb-4 text-uppercase">{{topSocialAdCreativesData.name}}</h1>
                    <div v-if="showQueries" v-html="this.query" style="width:100% !important;">{{ this.query }}</div>
                    <template v-if="!!missed_accounts.length">
                        <div v-for="missed_account in missed_accounts" class="missed-accounts my-3">There are no accounts connected for {{missed_account}}. Either connect an account or change the metrics/remove this section in the builder.</div>
                    </template>
                    <div v-if="reloading" class="spinner element-spinner d-flex flex-column justify-content-center align-items-center">
                        <span class="spinner-border spinner-border-sm margin-right5" role="status" aria-hidden="true"></span>
                    </div>
                    <!--<div class="col d-flex justify-content-between align-items-start flex-wrap">-->
                    <div class="col-12 mb-4">
                <span class="bubbles-wrap">
                    <template v-if="!edit_mode && bubbles_arr.length">
                        <span v-for="(title, idx) in bubbles_arr" :key="`bubble${idx}`" class="bubble-title text-uppercase">{{title}}</span>
                    </template>
                    <template v-if="!edit_mode && !bubbles_arr.length">
                        <span :key="`bubble`" class="bubble-title empty">Insert a comma separated list of titles (max 200 characters)</span>
                    </template>
                    <template v-if="show_error">
                        <span v-if="edit_mode" class="show-error">You cannot add more characters (max 200)</span><br v-if="edit_mode">
                    </template>
                    <template v-else>
                        <span v-if="edit_mode">Insert a comma separated list of titles (max 200 characters)</span><br v-if="edit_mode">
                    </template>
                    <span v-if="edit_mode" class="input-wrap" :key="`edit`"><input type="text" v-model="bubbles_str" maxlength="200" @keydown="onKeyDown" /></span>
                </span>
                        <template v-if="!isGuest">
                            <template v-if="!edit_mode && !bubbles_arr.length">
                                <span class="icon-wrap pencil-wrap empty" @click="editTitles"><img class="pencil-icon" :src="$store.state.app_url+'/images/data_sources/button_icons/pencil.svg'"></span>
                            </template>
                            <template v-else>
                                <span v-if="!edit_mode" class="icon-wrap pencil-wrap" @click="editTitles"><img class="pencil-icon" :src="$store.state.app_url+'/images/data_sources/button_icons/pencil.svg'"></span>
                                <span v-if="edit_mode" class="icon-wrap check-wrap" @click="saveTitles"><img class="pencil-icon" :src="$store.state.app_url+'/images/data_sources/button_icons/check.svg'"></span>
                            </template>
                        </template>
                    </div>
                    <div class="text-center d-flex flex-wrap justify-content-center">
                        <div v-if="!has_data && !reloading" class="nodata-container p-5 text-center">
                            <div v-if="errors" class="empty-data"><img :src="$store.state.app_url+'/images/errors.gif'"></div>
                            <div v-else class="empty-data"><img :src="$store.state.app_url+'/images/nodata.svg'"></div>
                        </div>
                        <template v-if="creative_type!='AD CREATIVES'">
                            <div v-for="creative in creatives" class="iframe-wrap grid-item mx-1 my-1">
                                <template v-if="creative.image_url">
                                    <div><img remote :src="creative.image_url"  alt="No Image found"/></div>
                                    <div class="metrics-box">
                                        <p v-for="metric in creative.metric_values"><span class="metric-name">{{metric.metric_name}}: </span><span class="metric-value">{{metric.metric_value}}</span></p>
                                    </div>
                                </template>
                                <template v-else>
                                    <div class="bordered">
                                        <div><img remote :src="creative.image_url"  alt="No Image found"/></div>
                                        <div class="metrics-box">
                                            <p v-for="metric in creative.metric_values"><span class="metric-name">{{metric.metric_name}}: </span><span class="metric-value">{{metric.metric_value}}</span></p>
                                        </div>
                                    </div>
                                </template>
                            </div>
                        </template>
                        <template v-else>
                            <div v-for="creative in creatives" class="iframe-wrap grid-item mx-1 my-1">
                                <template v-if="creative.image_url">
                                    <div class="v-scroll-overlay"></div>
                                    <div v-if="creative.platform == 'instagram'" class="h-scroll-overlay"></div>
                                    <iframe  class="border-0" :src="creative.image_url" :width="creative.w" :height="creative.h"></iframe>
                                    <div class="metrics-box">
                                        <p v-for="metric in creative.metric_values"><span class="metric-name">{{metric.metric_name}}: </span><span class="metric-value">{{metric.metric_value}}</span></p>
                                    </div>
                                </template>
                                <template v-else>
                                    <div class="bordered">
                                        <div class="v-scroll-overlay"></div>
                                        <div v-if="creative.platform == 'instagram'" class="h-scroll-overlay"></div>
                                        <iframe  class="border-0" :src="creative.image_url" :width="creative.w" :height="creative.h"></iframe>
                                        <div class="metrics-box">
                                            <p v-for="metric in creative.metric_values"><span class="metric-name">{{metric.metric_name}}: </span><span class="metric-value">{{metric.metric_value}}</span></p>
                                        </div>
                                    </div>
                                </template>
                            </div>
                        </template>
                    </div>
                </template>
            </div>
        </template>
        <template v-else-if="creative_type=='TOP STORIES'">
            <div class="not-ad-creatives mt-5">
                <div v-if="reloading" class="spinner element-spinner d-flex flex-column justify-content-center align-items-center">
                    <span class="spinner-border spinner-border-sm margin-right5" role="status" aria-hidden="true"></span>
                </div>
                <div class="row" v-if="!has_data && !reloading">
                    <h4 class="section-name my-3 text-uppercase">{{topSocialAdCreativesData.name}}</h4>
                </div>
                <div v-if="!has_data && !reloading" class="nodata-container p-5 text-center">
                    <div v-if="showQueries" v-html="this.query">{{ this.query }}</div>
                    <template v-if="errors">
                        <div class="empty-data"><img :src="$store.state.app_url+'/images/errors.gif'"></div>
                    </template>
                    <template v-else>
                        <div class="empty-data"><img :src="$store.state.app_url+'/images/nodata.svg'"></div>
                    </template>
                </div>
                <template v-if="has_data">
                    <div v-if="showQueries" v-html="this.query">{{ this.query }}</div>
                    <h4 class="section-name my-3 text-uppercase">{{topSocialAdCreativesData.name}}</h4>
                    <div class="row boxes-wrap likes justify-content-around mt-0 mb-0">
                        <div v-for="(creative, idx) in creatives" class="box-col likes flex-grow-1 d-flex justify-content-center" :class="'box_'+ ++idx">
                            <div class="img-wrap d-flex flex-column">
                                <div class="metrics-box" :class="creative.platform">
                                    <p v-for="metric in creative.metric_values"><span class="metric-name">{{metric.metric_name}}: </span><span class="metric-value">{{metric.metric_value}}</span></p>
                                </div>
                                <div class="inner-wrapper"><img remote :src="creative.full_picture" class="top-stories" alt="No Image found" /></div>
                            </div>
                        </div>
                    </div>
                </template>
            </div>
        </template>
        <template v-else>
            <div class="not-ad-creatives mt-5">
                <div v-if="reloading" class="spinner element-spinner d-flex flex-column justify-content-center align-items-center">
                    <span class="spinner-border spinner-border-sm margin-right5" role="status" aria-hidden="true"></span>
                </div>
                <div class="row" v-if="!has_data && !reloading">
                    <h4 class="section-name my-3 text-uppercase">{{topSocialAdCreativesData.name}}</h4>
                </div>
                <div v-if="!has_data && !reloading" class="nodata-container p-5 text-center">
                    <div v-if="showQueries" v-html="this.query">{{ this.query }}</div>
                    <template v-if="errors">
                        <div class="empty-data"><img :src="$store.state.app_url+'/images/errors.gif'"></div>
                    </template>
                    <template v-else>
                        <div class="empty-data"><img :src="$store.state.app_url+'/images/nodata.svg'"></div>
                    </template>
                </div>
                <template v-if="has_data">
                    <div v-if="showQueries" v-html="this.query">{{ this.query }}</div>
                    <h4 class="section-name my-3 text-uppercase">{{topSocialAdCreativesData.name}}</h4>
                    <div class="row boxes-wrap likes justify-content-around mt-0 mb-0">
                        <div v-for="(creative, idx) in creatives" class="box-col likes flex-grow-1 d-flex justify-content-center" :class="'box_'+ ++idx">
                            <div class="img-wrap d-flex flex-column">
                                <div class="metrics-box" :class="creative.platform">
                                    <p v-for="metric in creative.metric_values"><span class="metric-name">{{metric.metric_name}}: </span><span class="metric-value">{{metric.metric_value}}</span></p>
                                </div>
                                <div class="comment-wrap" :class="creative.platform">
                                    <img v-if="creative.platform=='inst'" :src="$store.state.app_url+'/images/social/instagram/header.png/'" />
                                    <img class="dots" :src="$store.state.app_url+'/images/social/dots.png'" />
                                    <img class="client-logo" :src="$store.state.app_url+'/images/client_logos/'+creative.client_logo" />
                                    <span class="account-name">{{creative.account_name}}<span class="date">{{creative.date}} <img class="globe" :src="$store.state.app_url+'/images/social/globe.png'" /></span></span>
                                    <template v-if="show_full_like">
                                        <span v-if="creative.platform=='fb'" class="message mt-2" v-html="creative.full_message" @mouseleave="hideFullLike">{{creative.full_message}}</span>
                                    </template>
                                    <template v-else>
                                        <span v-if="creative.platform=='fb'" class="message mt-2" v-html="creative.message" @mouseover="showFullLike">{{creative.message}}</span>
                                    </template>
                                </div>
                                <img remote :src="creative.full_picture" />
                                <div v-if="creative.platform=='fb'" class="socials d-flex justify-content-around mt-3">
                                    <span><img :src="$store.state.app_url+'/images/social/facebook/like.png'" /></span>
                                    <span><img :src="$store.state.app_url+'/images/social/facebook/comment.png'" /></span>
                                    <span><img :src="$store.state.app_url+'/images/social/facebook/share.png'" /></span>
                                </div>
                                <div v-if="creative.platform=='inst'" class="socials d-flex justify-content-around mt-3">
                                    <span><img :src="$store.state.app_url+'/images/social/instagram/like.png'" /></span>
                                    <span><img :src="$store.state.app_url+'/images/social/instagram/comment.png'" /></span>
                                    <span><img :src="$store.state.app_url+'/images/social/instagram/share.png'" /></span>
                                    <span><img :src="$store.state.app_url+'/images/social/instagram/save.png'" /></span>
                                </div>
                                <div v-if="creative.platform=='inst'" class="comment-wrap">
                                    <template v-if="show_full_like">
                                        <span class="message mt-2" v-html="creative.full_message" @mouseleave="hideFullLike">{{creative.full_message}}</span>
                                    </template>
                                    <template v-else>
                                        <span class="message mt-2" v-html="creative.message" @mouseover="showFullLike">{{creative.message}}</span>
                                    </template>
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
            </div>
        </template>
    </div>
</template>

<script>
    export default {
        props: ['isBuilt', 'hasSkb', 'topSocialAdCreativesData', 'isGuest'],
        created() {
            if(this.isBuilt){
                this.num_ads = this.topSocialAdCreativesData.element_configurations.num_ads_per_ds;
                this.show = this.topSocialAdCreativesData.element_configurations.select_data_sources;
                this.creative_type = this.topSocialAdCreativesData.element_configurations.select_creative_types || 'AD CREATIVES';
                event_bus.$on('current_dwm', () => {
                    this.current_dwm = this.$store.state.current_dwm;
                    event_bus.$emit('reloading', true);
                });
                this.fetchServerData();
                this.missed_accounts = this.checkAccounts(this.topSocialAdCreativesData);
            }
        },
        data() {
            return {
                isArchive:this.$store.state.isArchive,
                prefixed_id:null,
                creatives:[],
                num_ads:null,
                creative_type:'AD CREATIVES',
                has_data:null,
                edit_mode:false,
                bubbles_str:'',
                bubbles_arr:[],
                input_width:0,
                missed_accounts:[],
                max_lenght:0,
                show:'Facebook/Instagram',
                show_error:false,
                errors:false,
                query:'',
                showQueries:    this.$store.state.showQueries,
                reloading:true,
                show_full_like:false,
                show_full_message:false,
            }
        },
        mounted() {
            event_bus.$on('reloading', () => {
                this.reloading = true;
                this.fetchServerData();
            });
        },
        methods: {
            fetchServerData(){
                const vueInstance = this;
                const params = {
                    'isArchive':this.isArchive,
                    'prefixed_id': this.isArchive ? this.topSocialAdCreativesData.archive_id : this.topSocialAdCreativesData.report_id,
                    'element_abbr':this.topSocialAdCreativesData.element_abbreviation,
                    'dwm':this.$store.state.current_dwm,
                    'dates':this.$store.state.current_dates,
                    'element_id': this.topSocialAdCreativesData.element_id,
                    'prefixed_element_id': this.topSocialAdCreativesData.report_element_id,
                    'element_name': this.topSocialAdCreativesData.name,
                    'metrics': this.topSocialAdCreativesData.metrics,
                    'segment': this.topSocialAdCreativesData.segment,
                    'accounts': this.topSocialAdCreativesData.accounts,
                    'num_ads':this.num_ads,
                    'client_id':this.topSocialAdCreativesData.client_id,
                    'show':this.show,
                    'creative_type':this.creative_type,
                    'showQueries':this.showQueries,
                    'hasSkb':this.hasSkb,
                };
                axios.post('/api/reporting/element', params).then((response) => {
                    if(!!response.data && (typeof(response.data) == 'object')){
                        this.creatives = response.data.creatives;
                        this.query = response.data.query;
                        this.has_data = response.data.has_data;
                        this.bubbles_str = response.data.bubbles.bubbles_str;
                        this.bubbles_arr = response.data.bubbles.bubbles_arr;
                        this.errors = response.data.errors;
                    }

                    setTimeout(function(){
                        vueInstance.resizeBubbles();
                        vueInstance.reloading = false;
                        $('img.top-stories').each((idx, el) =>{
                            let $el = $(el);
                            if(($el.height() < 21) && ($el.width() > 100)){
                                $el.addClass('image-not-found')
                            };
                        });
                    }, 3000);
                });
            },
            editTitles(){
                const vueInstance = this;
                const report_element_id = this.topSocialAdCreativesData.report_element_id;
                axios.get(`/api/reporting/bubbles_need_refresh/${report_element_id}`).then((response) => {
                    if(response.data.success == false){
                        const message = "Something changed in the builder, so you need a page refresh before editing this element."
                        this.notification(message, 'type-warning', 'INFORMATION', BootstrapDialog.SIZE_SMALL, 5000, function(){location.reload()});
                    }
                    else{
                        this.edit_mode = true;
                        setTimeout(function(){
                            $('span.input-wrap').width(vueInstance.input_width);
                        }, 50)
                    }
                });
            },
            saveTitles(){
                const params = {
                    'prefixed_id': this.topSocialAdCreativesData.report_id,
                    'element_id': this.topSocialAdCreativesData.element_id,
                    'prefixed_element_id': this.topSocialAdCreativesData.report_element_id,
                    'bubbles':this.bubbles_str
                };

                axios.post('/api/reporting/element/save_bubbles', params).then((response) => {
                    if(response.data['need_refresh']){
                        const message = "This report have been modified in the builder and cannot be saved without losing this text. You will need to open a new version of this report and edit it again."
                        this.notification(message, 'type-warning', 'INFORMATION', BootstrapDialog.SIZE_SMALL, 20000);
                    }
                    else{
                        if(!!response.data && (typeof(response.data) == 'object')){
                            if(!response.data.error){
                                this.bubbles_str = response.data.bubbles_str;
                                this.bubbles_arr = response.data.bubbles_arr;
                            }
                        }
                        this.edit_mode = false;
                    }
                });
            },
            resizeBubbles(){
                this.input_width = $('span.bubbles-wrap').width();
            },
            onKeyDown(event){
                if(!!this.bubbles_str){
                    if(this.bubbles_str.length < this.max_lenght){
                        this.max_lenght = this.bubbles_str.length;
                    }
                    if(this.max_lenght >= 200){
                        const vueInstance = this;
                        this.show_error = true;
                        setTimeout(function(){
                            vueInstance.show_error = false;
                        }, 2000)
                    }
                    this.max_lenght = this.bubbles_str.length;
                }
            },
            showFullLike(){
                this.show_full_like = true;
            },
            hideFullLike(){
                this.show_full_like = false;
            },
            showFullMessage(){
                this.show_full_message = true;
            },
            hideFullMessage(){
                this.show_full_message = false;
            }
        }
    }
</script>
<style lang="scss">
    @import '~@/_variables.scss';
    .top-social-ad-creatives{
        span.bubble-title{
            display:inline-block;
            padding:0.6rem 2rem;
            border:0.2rem solid $black-blue;
            border-radius:2rem;
            font-size:1.2rem;
            font-weight:500;
            letter-spacing: 2px;
            margin-right:0.4rem;
            margin-bottom:0.2rem;
            &.empty{
                color:$gray-dark;
                &.pdf_exporting, &.ppt1_exporting, &.ppt2_exporting, &.slide_exporting{
                    display:none;
                }
            }
        }
        span.show-error{
            color:red;
            font-size:1.6rem;
        }
        span.icon-wrap{
            margin-left:0.6rem;
            img{
                height:2rem;
                cursor:pointer;
            }
            &.pdf_exporting, &.ppt1_exporting, &.ppt2_exporting, &.slide_exporting{
                display:none;
            }
        }
        span.input-wrap{
            display:inline-block;
            position:relative;
            input{
                width:100%;
            }
        }
        div.iframe-wrap{
            position:relative;
            min-width:20rem;
            min-height:8rem;
            div.v-scroll-overlay, div.h-scroll-overlay{
                position:absolute;
            }
            div.v-scroll-overlay{
                height:100%;
                top:0;
                right:0;
                width:2rem;
                background-color:$body-bg;
                &.pdf_exporting, &.ppt1_exporting, &.ppt2_exporting, &.slide_exporting {
                    background-color:white;
                }
            }
            div.h-scroll-overlay{
                height:3.7rem;
                left:0;
                bottom:0;
                width:34rem;
                background-color:$body-bg;
                &.pdf_exporting, &.ppt1_exporting, &.ppt2_exporting, &.slide_exporting {
                    background-color:white;
                }
            }
            div.metrics-box{
                position:absolute;
                top:40%;
                right:5%;
                padding:0.5rem 2rem;
                border-radius:2rem;
                font-size:1.2rem;
                background-color:white;
                box-shadow: 0.4rem 0.4rem 0.5rem #afafaf;
                z-index:9;
                p{
                    text-align:left;
                    padding:0;
                    margin:0;
                    span.metric-name{
                        font-weight:bold;
                    }
                }
                &.inst{
                    border-radius:1rem;
                }
            }
            div.bordered{
                border: solid #aaa 1px;
                width:180px;
            }
        }
        iframe{
            vertical-align: top;
            overflow:hidden;
        }
        div.nodata-container{
            background-color:white;
        }
        div.advert-wrap{
            img{
                max-width:100%;
            }
        }
        h1.advertising-title{
            font-size:5rem;
        }
    }
    div.not-ad-creatives{
        div.boxes-wrap{
            font-family:Helvetica, Arial, sans-serif;
            padding-bottom:0;

            div.box-col{
                position:relative;

                &.likes{
                    padding-bottom:2rem;
                    padding-top:6rem
                }
                &.shares{
                    padding-top:6rem;
                }
                div.box-header{
                    position:absolute;
                    top:1rem;
                    border:0.2rem solid $black-blue;
                    padding:0.5rem 1rem;
                    border-radius:2rem;
                    font-size:1.4rem;
                    font-weight:bold;
                }
                div.metrics-box{
                    position:absolute;
                    top:45%;
                    right:-10%;
                    padding:0.5rem 2rem;
                    border-radius:2rem;
                    font-size:1.2rem;
                    background-color:white;
                    box-shadow: 0.4rem 0.4rem 0.5rem #afafaf;
                    z-index:9;
                    p{
                        white-space:nowrap !important;
                        padding:0;
                        margin:0;
                        span.metric-name{
                            font-weight:bold;
                        }
                    }
                    &.inst{
                        border-radius:1rem;
                    }
                }
            }

            div.img-wrap{
                position:relative;
                padding-bottom:1rem;
                border:0.1rem solid $light-blue;
                min-width:13rem;
                text-align:center;
                img, div.comment-wrap{
                    position:relative;
                    max-width: 30rem;
                    font-size:1.2rem;
                    span{
                        display:inline-block;
                        padding:1rem;
                        &.account-name{
                            font-size:1.2rem;
                            font-weight:bold;
                            position:relative;
                            span.date{
                                position:absolute;
                                width:100%;
                                min-width:16rem;
                                bottom:-2rem;
                                font-weight:normal;
                                left:0;
                                img.globe{
                                    max-width:1rem;
                                    margin-top:-0.2rem;
                                }
                            }
                        }
                        b.more{
                            paddind:0;
                            font-size:1.2rem;
                            color:$gray-dark;
                        }
                    }
                    img.client-logo{
                        max-width:3rem;
                        margin-left:1rem;
                        border:0.1rem solid $gray;
                        border-radius:50%;
                    }
                    img.dots{
                        position:absolute;
                        top:0.8rem;
                        right:0.5rem;
                        max-height:0.4rem;
                    }
                    &.inst{
                        min-height:10rem;
                        img.dots{
                            top:4.2rem;
                        }
                    }
                }
                div.socials{
                    max-width: 30rem;
                    span{
                        display:inline-block;
                        img{
                            max-height:2rem;
                        }
                    }
                }
                &.shares{
                    min-width:30.2rem;
                }
                p.most-comment{
                    padding:0.5rem;
                    margin:0.4rem;
                    font-size:1.4rem;
                    max-width:29.2rem;
                    border:0.1rem solid $gray;
                }
                div.inner-wrapper{
                    overflow:hidden;
                    img.image-not-found{
                        margin-left:-16px;
                        min-width:150px;
                    }
                }
            }
        }
    }
</style>
